module.exports = __webpack_public_path__ + "img/geography.8c6ba44.svg";